import { HeaderItemProps } from "../types";



export const Header: React.FC<HeaderItemProps> = ({ title }) =>
{
    return <>{title()}</>;
};